<birdz-modal>
  <div modal-title>{{ 'CONTRACT_CONFIG_HELP.TITLE' | transloco }}</div>
  <div modal-body class="body">
    @if (kpis.length > 0) {
      @if (hasRawKpis) {
        <p>
          <span class="kpi-label">{{ 'RAW_TERM' | transloco }}</span
          >{{ 'COLON' | transloco }}{{ 'RAW_DEFINITION' | transloco }}.
        </p>
      }
      <p>
        <span class="kpi-label">{{ 'YTD_TERM' | transloco }}</span
        >{{ 'COLON' | transloco }}{{ 'YTD_DEFINITION' | transloco }}.
      </p>
      <br />
      <p>{{ 'CONTRACT_CONFIG_HELP.KPIS' | transloco }}</p>
      <ul>
        @for (kpi of kpis; track kpi) {
          <li [class]="{ 'birdz-admin': kpi.admin_birdz_display }">
            <span class="kpi-label">{{ getKpiLabel(kpi) }} </span>
            @if (data.techno === 'watermetering') {
              <span>{{ 'CONTRACT_CONFIG_HELP.FOR_DEVICES' | transloco }} </span>
              <span class="kpi-device-types">{{ kpi.device_types.join(', ') }}</span>
            }
            @if (data.techno === 'sewerin' || data.techno === 'kapta') {
              <span>: {{ getKpiDescription(kpi) }}</span>
            }
          </li>
        }
        @for (extra of extraKpis; track extra) {
          <li [class]="{ 'birdz-admin': extra.kpi.admin_birdz_display }">
            <span class="kpi-label"
              >{{ `EXTRA_KPI.${data.techno?.toUpperCase()}.${extra.extraKpi.toUpperCase()}` | transloco }}
            </span>
            <span>: {{ 'NON_COMPLIANCE_WITH_KPI' | transloco: { kpi: getContractualKpiLabel(extra.kpi) } }}</span>
          </li>
        }
      </ul>

      @if (showExplanation) {
        <br />
        <p>{{ 'CONTRACT_CONFIG_HELP.KPI_CALCULATIONS.TITLE' | transloco }}</p>
        <ul>
          @for (kpi of kpis; track kpi) {
            @if (kpi.weekly_display || kpi.monthly_display) {
              <li [innerHTML]="generateExplanation(kpi)" [class]="{ 'birdz-admin': kpi.admin_birdz_display }"></li>
            }
          }
        </ul>
      }
    }
  </div>
</birdz-modal>
